import { useEffect, useState } from 'react';

export const useScrollY = (dependencyArray) => {
  const [scrollY, setScrollY] = useState('0px');
  useEffect(() => setScrollY(`${window.scrollY}px`), dependencyArray);

  return scrollY;
};
